export async function selfServiceRegistrationAPI(baseUrl, payload, clientId) {
    try {
        return await fetch(`${baseUrl}/selfservice/user/registration?clientId=${clientId}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        });
    }
    catch (e) {
        console.error("Could not register user ☠");
        return { message: 'Could not register user', error: e };
    }
}
//# sourceMappingURL=SelfServiceRequests.js.map